module.exports = __webpack_public_path__ + "img/Pro2.2b57fc0f.png";